
document.querySelectorAll('.custom-accordion').forEach((accordion) => {
  const toggle = accordion.querySelector('.custom-accordion__toggle');

  if (!toggle) return;

  toggle.addEventListener('click', () => {
    const isOpen = accordion.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
});

function updateCustomCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const count = document.getElementById('custom_cart_count');

      if (!count) return;

      if (cart.item_count > 0) {
        count.textContent = `(${cart.item_count})`;
        count.style.display = '';
      } else {
        count.textContent = '';
        count.style.display = 'none';
      }
    });
}

document.addEventListener('ajaxProduct:added', updateCustomCartCount);